export default "__VITE_ASSET__Bb4x_XyH__"